import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './publicacion_pausa.css';

const PublicacionPausa = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { idAviso } = location.state || {};

  const [saldoActual, setSaldoActual] = useState(125000);
  const [horasParaPausar, setHorasParaPausar] = useState(1);
  const [diasPausaGratisRestantes, setDiasPausaGratisRestantes] = useState(5);
  const [diasPausaMaximo, setDiasPausaMaximo] = useState(5);
  const [horasGratisRestantes, setHorasGratisRestantes] = useState(120);
  const [minutosGratisRestantes, setMinutosGratisRestantes] = useState(7200);
  const [minutosRestoDisplay, setMinutosRestoDisplay] = useState(0);

  const formatHoras = (horas) => {
    const d = Math.floor(horas / 24);
    const h = horas % 24;
    return `${d} días - ${h} horas`;
  };
  const [planInfo, setPlanInfo] = useState({
    nombre: 'Premium',
    diasPublicados: 15,
    diasTotales: 30,
    diasRestantes: 15
  });

  useEffect(() => {
    cargarDatosAviso();
  }, []);

const cargarDatosAviso = async () => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_PUBLICACION_PAUSA_URL}/get_publicacionpausa.php?id_publicacion=${idAviso}`,
      { method: 'GET', credentials: 'include' }
    );
    const data = await response.json();

    if (!data.success) {
      console.error('Error al cargar datos:', data.message);
      return;
    }

    const d = data.data;
    setPlanInfo({
      nombre:         d.plan_nombre,
      precio:         d.plan_precio,
      diasPublicados: d.dias_publicados,
      diasTotales:    d.dias_totales,
      diasRestantes:  d.dias_restantes
    });
    setDiasPausaGratisRestantes(d.dias_gratis_restantes);
    setDiasPausaMaximo(d.dias_gratis_maximo);
    setHorasGratisRestantes(d.horas_gratis_restantes);
    setMinutosGratisRestantes(d.minutos_gratis_restantes);
    setMinutosRestoDisplay(d.mins_resto_display);
    setHorasParaPausar(1);
  } catch (error) {
    console.error('Error al cargar datos:', error);
  }
};


  const handleSliderChange = (e) => {
    setHorasParaPausar(parseInt(e.target.value));
  };

  const handleInputChange = (e) => {
    const valor = parseInt(e.target.value) || 1;
    if (valor >= 1 && valor <= horasGratisRestantes) {
      setHorasParaPausar(valor);
    }
  };

  const handleCancelar = () => {
    navigate('/gestion_avisos');
  };

const handleConfirmar = async () => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_PUBLICACION_PAUSA_URL}/put_confirmarpausa.php`,
      {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id_publicacion:    idAviso,
          horas_solicitadas: horasParaPausar
        })
      }
    );
    const data = await response.json();

    if (!data.success) {
      alert(`❌ ${data.message}`);
      return;
    }

    alert(`✅ Pausa confirmada por ${formatHoras(horasParaPausar)}.\nTu anuncio estará oculto hasta que lo reanudes.`);
    navigate('/gestion_avisos');
  } catch (error) {
    console.error('Error al pausar:', error);
    alert('Error al procesar la pausa. Intenta nuevamente.');
  }
};


  return (
    <>
      <div className="pausa-container">
      <div className="pausa-content">
        {/* HEADER */}
        <div className="pausa-header">
          <h2 className="pausa-titulo">⏸️ PAUSAR PUBLICACIÓN</h2>
          <button className="pausa-close" onClick={handleCancelar}>×</button>
        </div>

        {/* BODY */}
        <div className="pausa-body">
        {/* PLAN ACTUAL */}
          <div className="info-box">
            <div className="info-box-title">📋 Tu Plan Actual</div>
            <div className="info-box-content">
              <strong>Plan:</strong> {planInfo.nombre} (${planInfo.precio ? planInfo.precio.toLocaleString('es-CL') : '---'})<br/>
              <strong>Días publicados:</strong> {formatHoras(planInfo.diasPublicados * 24 + (planInfo.horasResto || 0))} / {planInfo.diasTotales} días<br/>
              <strong>Días restantes:</strong> {planInfo.diasRestantes} días
            </div>
          </div>

{/* PAUSAS DISPONIBLES */}
          <div className="info-box">
            <div className="info-box-title">⏸️ Pausas Disponibles</div>
            <div className="info-box-content">
              ✅ <strong>Pausas gratis restantes:</strong>{' '}
              <span style={{ color: minutosGratisRestantes < 120 ? '#CC0000' : '#008000', fontWeight: 'bold' }}>
                {horasGratisRestantes}h {minutosRestoDisplay}min
              </span><br/>
              ℹ️ Puedes reanudar en cualquier momento, solo se descontarán los minutos realmente usados.<br/>
              {minutosGratisRestantes < 360 && (
                <span style={{ color: '#CC0000', fontWeight: 'bold' }}>
                  ⚠️ Tu saldo de pausas está por agotarse. Úsalas con cuidado.
                </span>
              )}
            </div>
          </div>

          {/* SLIDER */}
          <div className="slider-container">
            <div className="slider-label">⏱️ ¿Por cuántas horas quieres pausar?</div>
            <div className="slider-input-group">
              <input 
                type="number" 
                className="slider-input" 
                value={horasParaPausar}
                onChange={handleInputChange}
                min="1"
                max={horasGratisRestantes}
              />
              <input 
                type="range" 
                className="slider" 
                value={horasParaPausar}
                onChange={handleSliderChange}
                min="1"
                max={horasGratisRestantes}
              />
              <span className="slider-text">{formatHoras(horasParaPausar)}</span>
            </div>
          </div>

          {/* CÁLCULO */}
          <div className="calculo-box">
            <div className="calculo-title">📊 Cálculo de Pausa</div>
            <div className="calculo-row">
              <span className="calculo-label">Horas a pausar:</span>
              <span className="calculo-valor">{formatHoras(horasParaPausar)}</span>
            </div>
            <div className="calculo-row">
              <span className="calculo-label">├─ Horas gratis disponibles después:</span>
              <span className="calculo-valor gratis">
                {formatHoras(horasGratisRestantes - horasParaPausar)}
              </span>
            </div>
          </div>

{/* INFORMACIÓN IMPORTANTE */}
          <div className="info-box">
            <div className="info-box-title">ℹ️ Información Importante</div>
            <div className="info-box-content info-box-lista">
              • Tu anuncio se ocultará completamente durante la pausa.<br/>
              • Los minutos pausados NO cuentan como tiempo de publicación — tu plan se extiende automáticamente.<br/>
              • Puedes reanudar en cualquier momento antes de que se agote la pausa.<br/>
              • Al agotar los minutos de pausa, tu publicación se reactiva sola.<br/>
              • El descuento es por minutos exactos — si pausas 1 hora y reanudas a los 20 minutos, solo se descuentan 20 minutos.<br/><br/>
              <strong>Ejemplo 1:</strong> Te quedan 10 horas activas y pausas 24 horas. Al terminar la pausa, retomas con 10 horas activas restantes.<br/><br/>
              <strong>Ejemplo 2:</strong> Pausas 2 horas pero reanudas a los 45 minutos. Solo se descuentan 45 minutos de tu saldo de pausas.<br/><br/>
              • <strong>Importante:</strong> Si tus horas activas se agotan después de reanudar y no renuevas, tu publicación pasará a estado VENCIDO.
            </div>
          </div>
        </div>

        {/* FOOTER */}
        <div className="pausa-footer">
          <button className="btn-cancelar" onClick={handleCancelar}>
            Cancelar
          </button>
          <button className="btn-confirmar" onClick={handleConfirmar}>
            ⏸️ Confirmar Pausa
          </button>
        </div>
      </div>
</div>

      {/* Footer */}
      <footer className="home-footer">
        <div className="home-footer-top">
          <div className="home-footer-redes">
            <a href="https://www.instagram.com/ulalaaaoficial" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
              <i className="fab fa-instagram"></i>
            </a>
            <a href="https://www.tiktok.com/@ulalaaaoficial2" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
              <i className="fab fa-tiktok"></i>
            </a>
            <a href="https://www.youtube.com/@ulalaaaoficial" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
              <i className="fab fa-youtube"></i>
            </a>
            <a href="https://wa.me/56929674732" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
              <i className="fab fa-whatsapp"></i>
            </a>
            <a href="#" className="home-footer-social-link">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{width:'22px',height:'22px'}}>
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.746l7.73-8.835L1.254 2.25H8.08l4.259 5.63 5.905-5.63zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
              </svg>
            </a>
            <a href="https://t.me/+56929674732" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
              <i className="fab fa-telegram"></i>
            </a>
          </div>
          <div className="home-footer-logo">
            <img
              src={`${process.env.REACT_APP_UPLOADS_URL}/logotipo_new8.jpg`}
              alt="Ulalaaa Logo"
              className="home-footer-logo-img"
            />
          </div>
          <div className="home-footer-legal-links">
            <a href="/textos-legales#terminos" className="home-footer-legal-btn">Información Legal - Términos y Condiciones</a>
            <a href="/textos-legales#privacidad" className="home-footer-legal-btn">Política de Privacidad</a>
          </div>
        </div>
        <div className="home-footer-texto">
          Ulalaaa, es un sitio web exclusivo para mayores de 18 años, tanto para las personas publicadas como las que lo visitan, las personas publicadas son verificadas de forma rigurosa, el cual han dado su consentimiento para ser publicadas, este sitio no es una agencia, es solo un medio publicitario que no interviene con ninguna relación laboral con las personas publicadas.
        </div>
        <div className="home-footer-copyright">
          ©2026 Ulalaaa - Todos los derechos Reservados.
        </div>
      </footer>
    </>
  );
};

export default PublicacionPausa;
